import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import SearchBar from '../../../components/utils/SearchBar'
import Table from '../../../components/utils/Table'
import { useDispatch, useSelector } from 'react-redux';
import { convertDateToRequiredFormatTZ } from '../../../helpers/commonFunction'
import LockedActivationActions from "../../../redux/lockedActivation/actions"
import Alert from '../../../components/utils/Alert';

const { getLockedActivationRequest, releaseActivationRequest, resetMessage } = LockedActivationActions

const ActivationRequest = () => {
    const dispatch = useDispatch();
    const [filterText, setFilterText] = useState("");
    const { lockedActivationResult, realselockActivationmessage, realselockActivationerror, loading } = useSelector((state) => state.lockedActivation);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const [releaselockloading, setReleaseLockLoading] = useState(null);


    useEffect(() => {
        dispatch(getLockedActivationRequest());
    }, [])

    useEffect(() => {
        if (realselockActivationmessage !== null && realselockActivationmessage !== undefined) {
            displayAlert(realselockActivationmessage, 'alert-success');
        }
        if (realselockActivationerror !== null && realselockActivationerror !== undefined) {
            displayAlert(realselockActivationerror, 'alert-danger');
        }
    }, [realselockActivationmessage, realselockActivationerror]);

    const handleFilterChange = (value) => {
        setFilterText(value);
    };
    const handleUnLockActivation = (activationID) => {
        setReleaseLockLoading(activationID);
        const unLockData = {
            activationId: activationID,
        }
        dispatch(releaseActivationRequest(unLockData));
    }
    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetMessage());
    }

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
        dispatch(resetMessage());
    };

    const columns = [
        { displayName: '#', key: 'key' },
        { displayName: 'TRANSACTION ID', key: 'transactionID' },
        { displayName: 'SERIAL NUMBER', key: 'serialNumber' },
        { displayName: 'LOCKED DATE', key: 'createdDate' },
        { displayName: 'LOCKED BY', key: 'lockedBy' },
        { displayName: 'ACTION', key: 'action' },
    ];

    const filteredItems = Array.isArray(lockedActivationResult) && lockedActivationResult.length > 0 ? lockedActivationResult.filter(item => {
        if (typeof filterText !== 'string' || typeof item !== 'object') return false;
        return Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(filterText.toLowerCase()));
    }) : [];

    var dataSource = filteredItems && filteredItems.length > 0 && filteredItems.map((item, key) => {
        return {
            key: key + 1,
            transactionID: item.TransactionID,
            serialNumber: item.SerialNumber,
            lockedBy: item.LockedBy,
            createdDate: convertDateToRequiredFormatTZ(item.CreatedDate),
            action: (
                releaselockloading === item.ActivationID ? (<div className="spinner-border text-secondary" role="status"> <span className="sr-only">Loading...</span> </div>) : (
                    <div className="icon iq-action-icon-box rounded-circle bg-secondary" onClick={() => handleUnLockActivation(item.ActivationID)} style={{ cursor: 'pointer' }} >
                        <i className="ri-lock-unlock-line"></i>
                    </div>
                )
            )
        }
    });


    return (
        <>
            {showAlert && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}
            <div className="col-md-3">
                <SearchBar onFilter={handleFilterChange} filterText={filterText} />
            </div>

            <Table columns={columns} loading={loading} data={dataSource} pagination={true} />

        </>
    )
}

export default ActivationRequest
